import { render, staticRenderFns } from "./RewardRule.vue?vue&type=template&id=4fb6a0ca"
import script from "./RewardRule.vue?vue&type=script&lang=js"
export * from "./RewardRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports